import logoImg from '../assets/logo.png'
import { useTranslation } from 'react-i18next'
import { LanguageSwitcher } from './LanguageSwitcher'
import config from '../config'

export const Footer: React.FC = () => {
  const { t } = useTranslation()
  const footer = t('footer', { returnObjects: true }) as any
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-900 text-white py-8 md:py-12 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Company Info Section - Compact on Mobile */}
        <div className="mb-6">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center">
              <img src={logoImg} alt="nazwolab.pl logo" className="h-10 md:h-12 mr-2 md:mr-3 object-contain" />
              <h3 className="text-lg md:text-xl font-bold">nazwolab.pl</h3>
            </div>
            <div className="md:hidden">
              <LanguageSwitcher />
            </div>
          </div>
          <p className="text-gray-400 text-sm md:text-base mb-4">{footer.description}</p>
          <div className="hidden md:block">
            <LanguageSwitcher />
          </div>
        </div>

        {/* Links Grid - 2 columns on mobile, 4 columns on desktop */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-6 md:gap-8 mb-8 pt-6 border-t border-gray-800">
          {/* Links Sections */}
          {Object.entries(footer.links).map(([sectionId, section]: [string, any]) => (
            <div key={sectionId}>
              <h4 className="font-semibold mb-3 text-sm md:text-base">{section.title}</h4>
              <ul className="space-y-2">
                {section.items
                  .filter((item: any) => {
                    // Hide pricing link if pricing is not visible
                    if (!config.features.pricingVisible && (item.href === '/pricing' || item.href === '#pricing')) {
                      return false
                    }
                    return true
                  })
                  .map((item: any, index: number) => (
                    <li key={index}>
                      <a
                        href={item.href}
                        className="text-gray-400 hover:text-white transition-colors duration-200 text-sm md:text-base"
                      >
                        {item.text}
                      </a>
                    </li>
                  ))}
              </ul>
            </div>
          ))}
        </div>

        {/* GDPR Notice */}
        <div className="border-t border-gray-700 pt-6 mb-4">
          <div className="bg-blue-900 rounded-lg p-3 md:p-4">
            <p className="text-xs md:text-sm text-blue-100">
              🍪 {footer.legal.gdpr}
            </p>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-700 pt-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2 md:gap-4">
            <p className="text-gray-400 text-xs md:text-sm text-center md:text-left">
              {footer.legal.copyright.replace('{{year}}', currentYear.toString())}
            </p>
            <div className="text-gray-400 text-xs text-center md:text-right">
              <p>{footer.legal.company_details}</p>
            </div>
          </div>
        </div>

      </div>
    </footer>
  )
}